var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayBlueFill = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.61,
    height: 12.195,
    viewBox: "0 0 15.61 12.195",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "display-fill",
    d: "M5.854,11.756A3.39,3.39,0,0,1,5.61,13.22H4.878a.488.488,0,0,0,0,.976h5.854a.488.488,0,0,0,0-.976H10a3.39,3.39,0,0,1-.244-1.463h3.9A1.911,1.911,0,0,0,15.61,9.8V3.951A1.911,1.911,0,0,0,13.659,2H1.951A1.911,1.911,0,0,0,0,3.951V9.8a1.911,1.911,0,0,0,1.951,1.951Z",
    transform: "translate(0 -2)",
    fill: "#126cfc"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayBlueFill);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNS42MSIgaGVpZ2h0PSIxMi4xOTUiIHZpZXdCb3g9IjAgMCAxNS42MSAxMi4xOTUiPgogIDxwYXRoIGlkPSJkaXNwbGF5LWZpbGwiIGQ9Ik01Ljg1NCwxMS43NTZBMy4zOSwzLjM5LDAsMCwxLDUuNjEsMTMuMjJINC44NzhhLjQ4OC40ODgsMCwwLDAsMCwuOTc2aDUuODU0YS40ODguNDg4LDAsMCwwLDAtLjk3NkgxMGEzLjM5LDMuMzksMCwwLDEtLjI0NC0xLjQ2M2gzLjlBMS45MTEsMS45MTEsMCwwLDAsMTUuNjEsOS44VjMuOTUxQTEuOTExLDEuOTExLDAsMCwwLDEzLjY1OSwySDEuOTUxQTEuOTExLDEuOTExLDAsMCwwLDAsMy45NTFWOS44YTEuOTExLDEuOTExLDAsMCwwLDEuOTUxLDEuOTUxWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtMikiIGZpbGw9IiMxMjZjZmMiLz4KPC9zdmc+Cg==";